export const APP_LANGUAGE_STORAGE_KEY = 'decoderAppLanguage';

const UI_TEXT = {
  en: {
    openMenu: 'Open menu',
    addToHomeScreen: 'Add to Home Screen',
    appLanguageLabel: 'Language / Idioma',
    englishLabel: 'English',
    spanishLabel: 'Español',
    foundationTitle: 'The Foundation',
    foundationContinueJourneyLabel: 'Continue where you left off',
    foundationJourneyViewPath: 'View the path',
    foundationJourneyPathTitle: 'The Journey Path',
    foundationJourneyCompleteTitle: 'You are fully caught up',
    foundationJourneyCompleteBody: 'You have completed all Journey lessons currently available. More courses are coming.',
    foundationJourneyGoLibrary: 'Go to the Library',
    foundationJourneyRedirecting: 'Taking you to your next lesson...',
    foundationJourneySequenceNote: 'The Journey follows a sequence — each lesson builds on the last. If you\'d rather explore freely, everything is available in the Library.',
    foundationLandingSubtitle: 'Your path to self-understanding — the concepts I found myself explaining over and over in session.',
    foundationStartHereTitle: 'Start Here',
    foundationStartHereSubtitle: 'Follow the full curriculum in order — the way therapy was meant to work.',
    foundationLibraryTitle: 'Full Library',
    foundationLibrarySubtitle: 'Browse all courses and episodes freely — go where you need to go.',
    foundationAboutTitle: 'What is this?',
    foundationAboutSubtitle: 'Learn how The Foundation works and how to get the most from it.',
    foundationAtlasTitle: 'The Emotional Atlas',
    foundationAtlasSubtitle: 'A reference guide to every emotion - what it\'s protecting, and what it looks like at its best.',
    foundationJourneyTitle: 'Start Here',
    foundationJourneySubtitle: 'The recommended path — follow in order for the full experience',
    foundationElectiveTitle: 'Elective Courses',
    foundationElectiveSubtitle: 'Elective Courses — explore what’s relevant to you',
    foundationAboutPageTitle: 'How The Foundation Works',
    foundationAboutPageSubtitle: 'The Foundation is your psychoeducation library — built from the concepts I found myself explaining over and over in sessions as a therapist.',
    foundationAboutFollowTitle: 'Follow The Journey',
    foundationAboutFollowBody: 'Start from the beginning and follow the curriculum in the order concepts are most useful. Each course builds on the last. This is the recommended path if you want the full therapeutic experience.',
    foundationAboutLibraryTitle: 'Browse The Library',
    foundationAboutLibraryBody: 'Go straight to whatever topic is most relevant to your life right now. Anxiety keeping you up? Start there. Struggling with relationships? Jump in. There\'s no wrong entry point.',
    foundationAboutDecoderTitle: 'Let The Decoder Guide You',
    foundationAboutDecoderBody: 'After sharing something with The Decoder, it will recommend a Foundation course based on what you shared. This is the most personalized path.',
    foundationAboutPromptTitle: 'Not sure where to start?',
    foundationAboutStartHereButton: 'Take me to Start Here',
    foundationAboutFullLibraryButton: 'Show me the Full Library',
    foundationAboutNote: 'New episodes are added monthly. Subscribers always have something to look forward to.',
    foundationCourseAdvisory: 'This course covers sensitive topics. Go gently, and consider professional support alongside it.',
    foundationCourseComingSoon: 'Episodes for this course are coming soon.',
    foundationCourseDetailsComingSoon: 'Course details coming soon',
    foundationCourseMetaEpisodeSingular: 'episode',
    foundationCourseMetaEpisodePlural: 'episodes',
    foundationCourseMetaReadSingular: 'read',
    foundationCourseMetaReadPlural: 'read',
    foundationCourseMetaFreeSingular: 'free episode',
    foundationCourseMetaFreePlural: 'free episodes',
    foundationOpenCourseButton: 'Open course →',
    foundationContinueFromEpisode: 'Continue from {episode}',
    foundationEpisodeFree: 'Free',
    foundationEpisodeUnlocked: 'Unlocked',
    foundationEpisodeLocked: 'Locked',
    foundationEpisodeRead: 'Read',
    foundationAtlasIntro: 'Emotions are not enemies to control or symptoms to erase. They are internal signals that carry information. This Atlas helps you understand each emotion in three ways: what it protects, how it appears when it takes over, and how it can serve you when integrated.',
    foundationAtlasSearchPlaceholder: 'Search emotions, blends, or patterns (e.g. fear, guilt, boundaries)',
    foundationAtlasCoreTitle: 'Seven Core Emotions',
    foundationAtlasResultLabel: 'result',
    foundationAtlasNoCoreResults: 'No core emotion matched your search.',
    foundationAtlasPurpose: 'Purpose',
    foundationAtlasRunningTitle: 'When this emotion is running you',
    foundationAtlasAdultTitle: 'When this emotion serves your adult self',
    foundationAtlasBlendsTitle: 'Emotional Blends',
    foundationAtlasNoBlendResults: 'No blends matched your search.',
    foundationAtlasBuiltFrom: 'Built from:',
    foundationAtlasHowToUseTitle: 'How to use this Atlas',
    foundationAtlasHowToUseBody: 'Pick one emotion you feel often. Study what it protects. Notice how it appears when it takes over. Then practice moving toward its integrated form.',
    foundationAtlasClosing: 'The goal isn\'t to feel "good" all the time. The goal is to become emotionally fluent, so your feelings inform you without controlling you.',
    foundationEpisodeComingSoon: 'This episode is coming soon. New content is added monthly from real therapy sessions.',
    foundationEpisodeEnjoy: 'Enjoy your episode.',
    foundationEpisodeLockedNotice: 'This episode is part of The Foundation library.',
    foundationPracticeButton: 'Practice with the Deliverer',
    foundationNextEpisode: 'Next episode',
    foundationFinishedCourse: 'You\'ve finished',
    foundationFinishedCourseSubtitle: 'Come back to any of these whenever you need them.',
    foundationFollowingJourney: 'Following the Journey?',
    foundationBackToLibraryHeading: 'Learning at your own pace?',
    foundationBackToLibraryButton: 'Back to the Full Library',
    foundationEpisodeLockedNoticeLong: 'This episode is part of The Foundation library.',
    foundationUnlockButton: 'Unlock The Foundation — $15/month',
    delivererTitle: 'The Deliverer',
    delivererSubtitle: 'Learn it. Practice it. Integrate it.',
    delivererIntro: 'Guided practices that turn understanding into skill. Each one is a structured conversation — with a beginning, a middle, and an end.',
    delivererMembershipNotice: 'Guided practices are part of the full membership.',
    delivererLockedTitle: 'Unlock everything — $15/month',
    delivererLockedBody: 'Guided practices are part of the full membership — along with The Foundation\'s complete course library. {duration}, one conversation at a time.',
    delivererLockedLater: 'Maybe later',
    delivererStartButton: 'Begin practice',
    delivererPracticeSteps: 'Practice Steps',
    delivererBackLabel: 'Back to The Deliverer',
    delivererPracticeComplete: 'That’s the exercise',
    delivererPracticeContinue: 'Take a moment before we continue. There’s no rush.',
    delivererPracticeReady: 'I\'m ready to talk',
    delivererPracticeStartOver: 'Start over',
    delivererPracticeCompletedOne: 'Completed 1 time',
    delivererPracticeCompletedMany: 'Completed {count} times',
    delivererPracticeLastPracticed: 'Last practiced',
    delivererPracticeNew: 'New',
    delivererPracticeCancel: 'Cancel',
    grounderTitle: 'The Grounder',
    grounderSubtitle: 'What does your nervous system need right now?',
    grounderSquareSettleIn: "Let's settle in",
    grounderSquareBreatheIn: 'Breathe in',
    grounderSquareHold: 'Hold',
    grounderSquareBreatheOut: 'Breathe out',
    grounderSquareOpenHands: 'Excellent — now open and close your hands',
    grounderSquareKeepBreathing: '(keep breathing)',
    grounderSquareKeepGoing: '(keep going)',
    grounderSquareNoStopHands: "(don't stop your hands)",
    grounderSquareTimer: 'Timer: ',
    grounderSquareStartOver: 'Start over',
    grounderSquarePaused: 'Paused',
    grounderCompassTitle: 'Emotional Compass',
    grounderCompassIntro: 'Let\'s figure out how you\'re feeling. Answer these two quick questions to locate yourself.',
    grounderCompassPleasant: 'How pleasant are you feeling right now?',
    grounderCompassPleasantLow: 'Very unpleasant',
    grounderCompassPleasantHigh: 'Very pleasant',
    grounderCompassActivation: 'How intense are your feelings right now?',
    grounderCompassActivationLow: 'Very calm',
    grounderCompassActivationHigh: 'Extremely intense',
    grounderCompassOpen: 'Open Emotional Compass',
    grounderCompassHide: 'Hide',
    grounderCompassBegin: 'Already know how you\'re feeling? Let\'s begin →',
    grounderCompassYourSystem: 'Your nervous system most closely resembles...',
    grounderCompassLearnMore: 'Learn more about this emotion →',
    grounderCompassLearnMoreLocked: 'Learn more about this emotion — part of The Foundation →',
    grounderCompassDeepen: 'If this doesn\'t resonate, the Emotions course in The Foundation explores this in more depth.',
    grounderCompassShift: 'You started here. Now you\'re here.',
    grounderCompassNoShift: 'Not much has shifted yet, and that\'s okay. Sometimes it takes more than one try.',
    grounderCompassCalm: 'Your nervous system appears calm and regulated. This often creates the best conditions for learning, reflection, and intentional decision-making.',
    grounderCompassCalmButton: '📚 Go to The Foundation',
    grounderCompassActivated: 'Your nervous system appears highly activated right now. This can make it difficult to think clearly. Let\'s help your body settle first. Then we\'ll decide what needs your attention.',
    grounderCompassSuggestion: 'Suggested: ',
    grounderCompassStartExercise: 'Start this exercise',
    grounderCompassOtherExercise: 'Or choose a different exercise.',
    grounderTalkPrompt: 'Still not sure, or want to talk it through? I can help you figure out what you\'re feeling.',
    grounderTalkButton: '💬 Talk it through with me',
    grounderBeginButton: 'Let\'s begin',
    grounderExerciseListPrompt: 'Or choose an exercise directly',
    grounderAvailability: 'Available anytime — you don\'t have to be in crisis to use this.',
    grounderChooserTitle: 'Choose whichever feels right — there\'s no wrong answer.',
    grounderChooserSuggested: 'Suggested for you',
    grounderWhyReady: 'I\'m ready to begin',
    grounderWhyChooseDifferent: 'Choose a different exercise',
    grounderExerciseBeginVoice: '🔊 Begin with my voice',
    grounderExerciseBeginSilent: 'Begin in silence',
    grounderExerciseCancel: 'Cancel',
    grounderExerciseReadyTalk: 'I\'m ready to talk',
    grounderExerciseStartOver: 'Start over',
    grounderExercisePause: '⏸ Pause',
    grounderExerciseResume: '▶ Resume',
    grounderExerciseStop: 'Stop',
    grounderExerciseTypeResponse: 'Type your response',
    grounderExerciseSend: 'Send',
    grounderExerciseComposerPlaceholder: 'However you\'re doing is okay.',
    grounderExerciseBack: 'Back',
    grounderExercisePhaseNoticing: 'Noticing',
    grounderExercisePhaseSettling: 'Settling',
    grounderExercisePhaseCheckingIn: 'Checking in',
    grounderExerciseCheckInPrompt: 'Before you move on, would you like to quickly check where you are now?',
    grounderExerciseCheckInButton: 'See where you are now',
    grounderExerciseCheckInReturn: 'I\'m ready',
    grounderPracticeSuggestionTitle: 'Your body has settled',
    grounderPracticeSuggestionBody: 'Sometimes that\'s enough. But if the thoughts underneath are still loud, there\'s a practice that helps organize them — it takes one overwhelming worry and separates it into the pieces hiding inside it.',
    grounderPracticeSuggestionButton: '🧭 Try Big Square, Small Squares',
    grounderPracticeSuggestionUpgrade: '✦ Unlock The Deliverer — $15/month',
    grounderPracticeSuggestionMembership: 'Guided practices are part of the full membership.',
    grounderPracticeSuggestionLater: 'No thanks, I\'m good',
  },
  es: {
    openMenu: 'Abrir menú',
    addToHomeScreen: 'Agregar a la pantalla de inicio',
    appLanguageLabel: 'Idioma / Language',
    englishLabel: 'English',
    spanishLabel: 'Español',
    foundationTitle: 'La Fundación',
    foundationContinueJourneyLabel: 'Continúa donde lo dejaste',
    foundationJourneyViewPath: 'Ver el camino',
    foundationJourneyPathTitle: 'El camino del Viaje',
    foundationJourneyCompleteTitle: 'Estás al día',
    foundationJourneyCompleteBody: 'Has completado todas las lecciones del Viaje disponibles por ahora. Pronto llegarán más cursos.',
    foundationJourneyGoLibrary: 'Ir a la Biblioteca',
    foundationJourneyRedirecting: 'Te llevamos a tu próxima lección...',
    foundationJourneySequenceNote: 'El Viaje sigue una secuencia — cada lección se apoya en la anterior. Si prefieres explorar libremente, todo está disponible en la Biblioteca.',
    foundationLandingSubtitle: 'Tu camino hacia la autocomprensión — los conceptos que seguía explicando una y otra vez en sesión.',
    foundationStartHereTitle: 'Empieza aquí',
    foundationStartHereSubtitle: 'Sigue el plan completo en orden — así es como la terapia estaba destinada a funcionar.',
    foundationLibraryTitle: 'Biblioteca completa',
    foundationLibrarySubtitle: 'Explora todos los cursos y episodios libremente — ve a donde lo necesites.',
    foundationAboutTitle: '¿Qué es esto?',
    foundationAboutSubtitle: 'Aprende cómo funciona La Fundación y cómo aprovecharla al máximo.',
    foundationAtlasTitle: 'El Atlas Emocional',
    foundationAtlasSubtitle: 'Una guía de referencia para cada emoción: lo que protege y cómo se ve en su mejor versión.',
    foundationJourneyTitle: 'Empieza aquí',
    foundationJourneySubtitle: 'La ruta recomendada — síguela en orden para la experiencia completa',
    foundationElectiveTitle: 'Cursos electivos',
    foundationElectiveSubtitle: 'Cursos electivos — explora lo que te sea más relevante',
    foundationAboutPageTitle: 'Cómo funciona La Fundación',
    foundationAboutPageSubtitle: 'La Fundación es tu biblioteca de psicoeducación — creada a partir de los conceptos que seguía explicando una y otra vez en sesiones como terapeuta.',
    foundationAboutFollowTitle: 'Sigue el recorrido',
    foundationAboutFollowBody: 'Empieza por el principio y sigue el currículo en el orden en que los conceptos son más útiles. Cada curso se construye sobre el anterior. Esta es la ruta recomendada si quieres la experiencia terapéutica completa.',
    foundationAboutLibraryTitle: 'Explora la biblioteca',
    foundationAboutLibraryBody: 'Ve directo a cualquier tema que sea más relevante para tu vida ahora mismo. ¿La ansiedad te mantiene despierto? Empieza ahí. ¿Tienes problemas en tus relaciones? Entra. No existe un punto de inicio incorrecto.',
    foundationAboutDecoderTitle: 'Deja que El Decodificador te guíe',
    foundationAboutDecoderBody: 'Después de compartir algo con El Decodificador, te recomendará un curso de La Fundación basado en lo que compartiste. Esta es la ruta más personalizada.',
    foundationAboutPromptTitle: '¿No sabes por dónde empezar?',
    foundationAboutStartHereButton: 'Llévame a Empieza aquí',
    foundationAboutFullLibraryButton: 'Muéstrame la biblioteca completa',
    foundationAboutNote: 'Cada mes se agregan episodios nuevos. Los suscriptores siempre tienen algo que esperar.',
    foundationCourseAdvisory: 'Este curso aborda temas sensibles. Ve con suavidad y considera apoyo profesional junto con él.',
    foundationCourseComingSoon: 'Los episodios de este curso llegarán pronto.',
    foundationCourseDetailsComingSoon: 'Detalles del curso próximamente',
    foundationCourseMetaEpisodeSingular: 'episodio',
    foundationCourseMetaEpisodePlural: 'episodios',
    foundationCourseMetaReadSingular: 'leído',
    foundationCourseMetaReadPlural: 'leídos',
    foundationCourseMetaFreeSingular: 'episodio gratis',
    foundationCourseMetaFreePlural: 'episodios gratis',
    foundationOpenCourseButton: 'Abrir curso →',
    foundationContinueFromEpisode: 'Continuar desde {episode}',
    foundationEpisodeFree: 'Gratis',
    foundationEpisodeUnlocked: 'Desbloqueado',
    foundationEpisodeLocked: 'Bloqueado',
    foundationEpisodeRead: 'Leído',
    foundationAtlasIntro: 'Las emociones no son enemigos que hay que controlar ni síntomas que hay que borrar. Son señales internas que transmiten información. Este atlas te ayuda a entender cada emoción de tres maneras: qué protege, cómo aparece cuando te domina y cómo puede servirte cuando está integrada.',
    foundationAtlasSearchPlaceholder: 'Busca emociones, combinaciones o patrones (por ejemplo: miedo, culpa, límites)',
    foundationAtlasCoreTitle: 'Siete emociones centrales',
    foundationAtlasResultLabel: 'resultado',
    foundationAtlasNoCoreResults: 'Ninguna emoción central coincidió con tu búsqueda.',
    foundationAtlasPurpose: 'Propósito',
    foundationAtlasRunningTitle: 'Cuando esta emoción te domina',
    foundationAtlasAdultTitle: 'Cuando esta emoción sirve a tu yo adulto',
    foundationAtlasBlendsTitle: 'Combinaciones emocionales',
    foundationAtlasNoBlendResults: 'Ninguna combinación coincidió con tu búsqueda.',
    foundationAtlasBuiltFrom: 'Se construye a partir de:',
    foundationAtlasHowToUseTitle: 'Cómo usar este atlas',
    foundationAtlasHowToUseBody: 'Elige una emoción que sientas con frecuencia. Estudia lo que protege. Observa cómo aparece cuando te domina. Luego practica moverte hacia su forma integrada.',
    foundationAtlasClosing: 'La meta no es sentirte “bien” todo el tiempo. La meta es volverte emocionalmente fluido para que tus sentimientos te informen sin controlarte.',
    foundationEpisodeComingSoon: 'Este episodio llegará pronto. Cada mes se agregan nuevos contenidos de sesiones reales de terapia.',
    foundationEpisodeEnjoy: 'Disfruta tu episodio.',
    foundationEpisodeLockedNotice: 'Este episodio forma parte de la biblioteca de La Fundación.',
    foundationPracticeButton: 'Practica con El Aplicador',
    foundationNextEpisode: 'Siguiente episodio',
    foundationFinishedCourse: 'Has terminado',
    foundationFinishedCourseSubtitle: 'Vuelve a cualquiera de estos cuando lo necesites.',
    foundationFollowingJourney: '¿Sigues el recorrido?',
    foundationBackToLibraryHeading: '¿Aprendes a tu propio ritmo?',
    foundationBackToLibraryButton: 'Volver a la biblioteca completa',
    foundationEpisodeLockedNoticeLong: 'Este episodio forma parte de la biblioteca de La Fundación.',
    foundationUnlockButton: 'Desbloquea La Fundación — $15/mes',
    delivererTitle: 'El Aplicador',
    delivererSubtitle: 'Apréndelo. Practícalo. Intégralo.',
    delivererIntro: 'Prácticas guiadas que convierten la comprensión en habilidad. Cada una es una conversación estructurada: con inicio, desarrollo y cierre.',
    delivererMembershipNotice: 'Las prácticas guiadas forman parte de la membresía completa.',
    delivererLockedTitle: 'Desbloquea todo — $15/mes',
    delivererLockedBody: 'Las prácticas guiadas forman parte de la membresía completa — junto con la biblioteca completa de La Fundación. {duration}, una conversación a la vez.',
    delivererLockedLater: 'Quizá después',
    delivererStartButton: 'Comenzar la práctica',
    delivererPracticeSteps: 'Pasos de la práctica',
    delivererBackLabel: 'Volver a El Aplicador',
    delivererPracticeComplete: 'Esa es la práctica',
    delivererPracticeContinue: 'Tómate un momento antes de continuar. No hay prisa.',
    delivererPracticeReady: 'Estoy listo para hablar',
    delivererPracticeStartOver: 'Empezar de nuevo',
    delivererPracticeCompletedOne: 'Completado 1 vez',
    delivererPracticeCompletedMany: 'Completado {count} veces',
    delivererPracticeLastPracticed: 'Practicado por última vez',
    delivererPracticeNew: 'Nuevo',
    delivererPracticeCancel: 'Cancelar',
    grounderTitle: 'El Anclador',
    grounderSubtitle: '¿Qué necesita tu sistema nervioso en este momento?',
    grounderSquareSettleIn: 'Vamos a acomodarnos',
    grounderSquareBreatheIn: 'Inhala',
    grounderSquareHold: 'Sostén',
    grounderSquareBreatheOut: 'Exhala',
    grounderSquareOpenHands: 'Excelente — ahora abre y cierra las manos',
    grounderSquareKeepBreathing: '(sigue respirando)',
    grounderSquareKeepGoing: '(continúa)',
    grounderSquareNoStopHands: '(no detengas las manos)',
    grounderSquareTimer: 'Temporizador: ',
    grounderSquareStartOver: 'Empezar de nuevo',
    grounderSquarePaused: 'En pausa',
    grounderCompassTitle: 'Brújula emocional',
    grounderCompassIntro: 'Veamos cómo te sientes. Responde estas dos preguntas rápidas para ubicarte.',
    grounderCompassPleasant: '¿Qué tan agradable te sientes ahora mismo?',
    grounderCompassPleasantLow: 'Muy desagradable',
    grounderCompassPleasantHigh: 'Muy agradable',
    grounderCompassActivation: '¿Qué tan intensa es tu emoción ahora mismo?',
    grounderCompassActivationLow: 'Muy calmado',
    grounderCompassActivationHigh: 'Extremadamente intensa',
    grounderCompassOpen: 'Abrir brújula emocional',
    grounderCompassHide: 'Ocultar',
    grounderCompassBegin: '¿Ya sabes cómo te sientes? Empecemos →',
    grounderCompassYourSystem: 'Tu sistema nervioso se asemeja más a...',
    grounderCompassLearnMore: 'Aprende más sobre esta emoción →',
    grounderCompassLearnMoreLocked: 'Aprende más sobre esta emoción — parte de La Fundación →',
    grounderCompassDeepen: 'Si esto no resuena, el curso de Emociones en La Fundación lo explora con más profundidad.',
    grounderCompassShift: 'Comenzaste aquí. Ahora estás aquí.',
    grounderCompassNoShift: 'Todavía no ha cambiado mucho, y eso está bien. A veces hace falta más de un intento.',
    grounderCompassCalm: 'Tu sistema nervioso parece calmado y regulado. Esto suele crear las mejores condiciones para aprender, reflexionar y tomar decisiones intencionales.',
    grounderCompassCalmButton: '📚 Ir a La Fundación',
    grounderCompassActivated: 'Tu sistema nervioso parece muy activado ahora mismo. Esto puede dificultar pensar con claridad. Ayudemos primero a que tu cuerpo se calme. Luego decidiremos qué necesita tu atención.',
    grounderCompassSuggestion: 'Sugerido: ',
    grounderCompassStartExercise: 'Comenzar este ejercicio',
    grounderCompassOtherExercise: 'O elige un ejercicio distinto.',
    grounderTalkPrompt: '¿Todavía no estás seguro o quieres hablarlo? Puedo ayudarte a entender qué sientes.',
    grounderTalkButton: '💬 Háblame de lo que sientes',
    grounderBeginButton: 'Empecemos',
    grounderExerciseListPrompt: 'O elige un ejercicio directamente',
    grounderAvailability: 'Disponible en cualquier momento — no necesitas estar en crisis para usarlo.',
    grounderChooserTitle: 'Elige lo que te parezca correcto — no hay una respuesta incorrecta.',
    grounderChooserSuggested: 'Sugerido para ti',
    grounderWhyReady: 'Estoy listo para empezar',
    grounderWhyChooseDifferent: 'Elegir un ejercicio distinto',
    grounderExerciseBeginVoice: '🔊 Empezar con mi voz',
    grounderExerciseBeginSilent: 'Empezar en silencio',
    grounderExerciseCancel: 'Cancelar',
    grounderExerciseReadyTalk: 'Estoy listo para hablar',
    grounderExerciseStartOver: 'Empezar de nuevo',
    grounderExercisePause: '⏸ Pausar',
    grounderExerciseResume: '▶ Reanudar',
    grounderExerciseStop: 'Detener',
    grounderExerciseTypeResponse: 'Escribe tu respuesta',
    grounderExerciseSend: 'Enviar',
    grounderExerciseComposerPlaceholder: 'Como estés está bien.',
    grounderExerciseBack: 'Volver',
    grounderExercisePhaseNoticing: 'Notando',
    grounderExercisePhaseSettling: 'Acomodando',
    grounderExercisePhaseCheckingIn: 'Revisando',
    grounderExerciseCheckInPrompt: 'Antes de seguir, ¿quieres comprobar rápido dónde estás ahora?',
    grounderExerciseCheckInButton: 'Ver dónde estás ahora',
    grounderExerciseCheckInReturn: 'Estoy listo',
    grounderPracticeSuggestionTitle: 'Tu cuerpo se ha calmado',
    grounderPracticeSuggestionBody: 'A veces eso basta. Pero si los pensamientos debajo siguen muy fuertes, existe una práctica que los organiza — toma una preocupación abrumadora y la separa en las piezas que hay dentro.',
    grounderPracticeSuggestionButton: '🧭 Prueba Cuadrado grande, cuadrados pequeños',
    grounderPracticeSuggestionUpgrade: '✦ Desbloquea El Aplicador — $15/mes',
    grounderPracticeSuggestionMembership: 'Las prácticas guiadas forman parte de la membresía completa.',
    grounderPracticeSuggestionLater: 'No, gracias, ya estoy bien',
  },
};

export const normalizeAppLanguage = (value) => {
  if (value === 'es') return 'es';
  return 'en';
};

export const readStoredAppLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  return normalizeAppLanguage(window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY));
};

export const getLocalizedValue = (englishValue, spanishValue, language) => {
  if (language === 'es' && typeof spanishValue !== 'undefined' && spanishValue !== null && spanishValue !== '') {
    return spanishValue;
  }
  return englishValue ?? '';
};

export const getUIText = (language, key, fallback = '') => {
  const normalizedLanguage = normalizeAppLanguage(language);
  const translations = UI_TEXT[normalizedLanguage] || UI_TEXT.en || {};
  return translations[key] || fallback;
};

export const getLocalizedAudioPath = (path, language, hasSpanishAudio = false) => {
  if (!path) return path;
  if (language !== 'es' || !hasSpanishAudio) return path;
  const match = String(path).match(/^(.*?)(\.mp3|\.m4a)(\?.*)?$/i);
  if (!match) return path;
  const [, base, ext, suffix = ''] = match;
  return `${base}-es${ext}${suffix}`;
};
